import { css } from 'styled-components';

const ContentPosition = {
    center: css`
        align-items: center;
        text-align: center;
    `,
    left: css`
        align-items: self-start;
        text-align: left;
    `,
    right: css`
        align-items: self-end;
        text-align: right;
    `,
};

const styles = {
    position: ContentPosition,
};

export default styles;
